export default function openInNewTab(url: string): void {
  if (url) {
    const urlWindow = window.open(url, '_blank')

    // taken from the old version to deal with IE11
    // https://github.com/articulate/360-frontend/blob/1d1150432f08a45fae81f284cc370e19b95aed95/src/js/components/pages/Live/Sessions.js#L143
    setTimeout(() => {
      if (!urlWindow || urlWindow.closed || typeof urlWindow.closed === 'undefined') {
        window.location.href = url
      } else {
        urlWindow.focus()
      }
    }, 500)
  }
}
